import { SelectionPanel } from '$tablet-app/src/app/components/SelectionPanel';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import React from 'react';
import styled from 'styled-components/native';
import { useMealPreferenceDialogState } from '../../store/useMealPreferenceDialogState';

const TimeAndEffortPreferenceView = () => {
  const time_and_effort = useMealPreferenceDialogState(
    (state) => state.draft_preferences.time_and_effort
  );

  const update = useMealPreferenceDialogState(
    (state) => state.updatePreference
  );

  const onChangeSlider = (time_and_effort: number) =>
    update({ time_and_effort });

  return (
    <Container>
      <Text weight="semibold">
        Select home much effort are happy to put into your meals
      </Text>
      <Row>
        <SelectionPanel
          title="Quick and easy"
          value={0}
          icon="bread-slice"
          selected={time_and_effort === 0}
          iconColor={colors.blue[700]}
          backgroundColor={colors.blue.background}
          onPress={onChangeSlider}
        />
        <SelectionPanel
          title="Moderate"
          value={2}
          icon="salad"
          selected={time_and_effort === 2}
          iconColor={colors.green[700]}
          backgroundColor={colors.green.background}
          onPress={onChangeSlider}
        />
        <SelectionPanel
          title="Fancy Meals"
          value={4}
          icon="user-chef"
          selected={time_and_effort === 4}
          iconColor={colors.yellow[700]}
          backgroundColor={colors.yellow.background}
          onPress={onChangeSlider}
        />
      </Row>
    </Container>
  );
};

const Container = styled.View`
  padding: 30px;
  padding-top: 0;

  align-items: center;
  gap: 30px;
`;

const Row = styled.View`
  flex-direction: row;
  gap: 30px;
`;

export default TimeAndEffortPreferenceView;
